import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import Disclaimer from "@/components/Disclaimer";
import ResetAssessment from "@/components/ResetAssessment";
import { Users } from "lucide-react";
import { useCosmetics } from "@/lib/cosmetics";
import { FramePicker } from "@/components/cosmetics/FramePicker";
import { ThemePicker } from "@/components/cosmetics/ThemePicker";

export default function SettingsPage() {
  const { user, logout } = useAuth();
  const cosmetics = useCosmetics();
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/settings").then((r) => setS(r.data)); }, []);

  return (
    <div className="p-4 sm:p-6 lg:p-8 max-w-2xl mx-auto space-y-6">
      <h1 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight">Settings</h1>
      <div className="tc-card p-5 space-y-3">
        <Row k="Name" v={user?.name} />
        <Row k="Email" v={user?.email} />
        <Row k="Role" v={user?.role} />
        {s && <>
          <Row k="Simulated Balance" v={`$${s.balance?.toLocaleString?.() ?? s.balance}`} />
          <Row k="Default Risk" v={`${s.risk_percent}%`} />
          <Row k="Max Risk" v={`${s.max_risk_percent}%`} />
        </>}
      </div>
      {user?.role === "student" && (
        <div className="tc-card p-5">
          <p className="text-sm text-tc-sub">Simulation settings such as balance and risk are managed by your parent/admin from the Parent dashboard.</p>
        </div>
      )}
      <ResetAssessment />
      {cosmetics && <FramePicker state={cosmetics} name={user?.name} />}
      {cosmetics && <ThemePicker state={cosmetics} />}
      <Link to="/family" data-testid="settings-family-link" className="tc-card p-5 flex items-center justify-between hover:border-tc-coach/40 transition-colors group">
        <div className="flex items-center gap-3">
          <Users className="w-5 h-5 text-tc-coach" />
          <div>
            <div className="text-sm font-semibold">Family</div>
            <p className="text-xs text-tc-muted">Link a guardian or a family member, manage invitations and access.</p>
          </div>
        </div>
        <span className="text-tc-muted group-hover:text-tc-coach text-lg">&rarr;</span>
      </Link>
      <button data-testid="settings-logout" onClick={logout} className="rounded-lg bg-tc-bear/15 border border-tc-bear/30 text-tc-bear px-5 py-2.5 text-sm font-medium hover:bg-tc-bear/25">Log out</button>
      <Disclaimer />
    </div>
  );
}
function Row({ k, v }) { return (<div className="flex justify-between text-sm"><span className="text-tc-muted">{k}</span><span className="font-mono">{v}</span></div>); }
